import styled from 'styled-components';
export const Wrapper = styled.div `
  position: relative;
  width: 100%;
  max-width: 100vw;
  padding: 16px;
  display: none;
  align-items: stretch;
  justify-content: center;
  z-index: 9999;
  color: #efefef;
  background-color: #666;
  border-bottom: 1px solid rgba(0,0,0,.125);

  &[data-ui-kit-visible="true"] {
    display: flex;
  }

  &[data-ui-kit-color="red"] {
    color: #efefef;
    background-color: #e1251b;
  }

  &[data-ui-kit-color="blue"] {
    color: #efefef;
    background-color: #0A67DC;
  }

  &[data-ui-kit-color="yellow"] {
    color: #000;
    background-color: #fbde00;
  }

  &[data-ui-kit-color="purple"] {
    color: #efefef;
    background-color: #3d1952;
  }
`;
export const Content = styled.div `
  font-size: 18px;

  @media only screen and (max-width: 767px) {
    font-size: calc(1.5vw + 8px);
  }

  p, ol, ul {
    width: 100%;
    margin: 0 0 .75em;
    line-height: 1.25;
    font-size: inherit;
    color: inherit;
  }

  a {
    font-size: inherit;
    color: inherit;
    text-decoration: underline;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;
export const Close = styled.button.attrs({ type: 'button' }) `
  width: 36px;
  margin: 0;
  padding: 0 5px 0 0;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  appearance: none;
  border: none;
  outline: none;
  background: none;
`;
//# sourceMappingURL=styles.js.map